import React, { useState } from 'react';
import GreenPageSection from 'components/GreenPageSection';
import Subheading from 'components/Subheading';
import { colors } from 'utils/constants';

export const NeedHelpSection = ({ email }) => {
  return (
    <GreenPageSection additionalClassName="needHelpSection">
      <>
        <Subheading>
          Need <strong>help?</strong>
        </Subheading>

        <div className="questionPromptSection fullWidth flexCentered">
          <p>
            Our support page will help answer your most frequent questions! Have
            a look{' '}
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="https://daymade.zendesk.com/hc/en-gb"
            >
              here
            </a>
            .
          </p>
        </div>
      </>

      <style jsx>
        {`
          .questionContainer {
            height: 40px;
            padding: 0 1.5em;
            border-radius: 20px;
            background-color: white;
          }

          a {
            text-decoration: underline;
          }

          .question {
            outline: none;
            border: none;
            resize: none;
            white-space: nowrap;
            overflow-x: scroll;
            width: 100%;
            line-height: 35px;
            font-family: 'Montserrat', sans-serif;
            color: ${colors.primaryBrandGray};
            font-weight: 600;
          }

          .question::-webkit-scrollbar {
            display: none;
          }

          :global(.submitButton) {
            min-width: 230px;
            margin: 2em 0 0;
          }

          @media (min-width: 550px) {
            :global(.needHelpSection .subheading) {
              text-align: left;
              max-width: 140px;
              margin-bottom: 0;
              margin-right: 1em;
            }

            :global(.needHelpSection .subheading > *) {
              font-size: 1.2em;
            }

            p {
              text-align: left;
              margin-left: 0.1em;
              width: 100%;
            }

            .questionForm {
              flex-direction: row;
              gap: 1em;
            }

            :global(.needHelpSection.paddedMaxWidthContainer) {
              flex-direction: row;
            }

            :global(.submitButton) {
              margin-top: 0;
              min-width: 120px;
            }
          }

          @media (min-width: 650px) {
            :global(.needHelpSection .subheading) {
              max-width: 180px;
            }

            :global(.needHelpSection .subheading > *) {
              font-size: 1.5em;
            }
          }
        `}
      </style>
    </GreenPageSection>
  );
};

export default NeedHelpSection;
